var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.5959C2.07459e-06 14.2151 0.154705 13.8506 0.428635 13.586L1.45759 12.5922C1.84928 12.2139 2.06977 11.6922 2.06814 11.1476L2.05867 7.9946C2.04543 3.58319 5.61789 0 10.0293 0C14.4314 0 18 3.56859 18 7.97067L18 11.1716C18 11.702 18.2107 12.2107 18.5858 12.5858L19.5858 13.5858C19.851 13.851 20 14.2107 20 14.5858C20 15.3668 19.3668 16 18.5858 16H14C14 18.2091 12.2091 20 10 20C7.79086 20 6 18.2091 6 16H1.40408C0.628628 16 0 15.3714 0 14.5959ZM8 16C8 17.1046 8.89543 18 10 18C11.1046 18 12 17.1046 12 16H8ZM16 11.1716C16 12.2324 16.4214 13.2499 17.1716 14L2.87851 14C3.64222 13.246 4.07136 12.2161 4.06813 11.1416L4.05867 7.9886C4.04875 4.6841 6.7248 2 10.0293 2C13.3268 2 16 4.67316 16 7.97067L16 11.1716Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.de4f4f8bcfd4be05fa76457cd9869c32.svg";
export { ForwardRef as ReactComponent };